import { render, staticRenderFns } from "./orderDetailModal.vue?vue&type=template&id=5e948872&scoped=true&"
import script from "./orderDetailModal.vue?vue&type=script&lang=js&"
export * from "./orderDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e948872",
  null
  
)

export default component.exports